// extracted by mini-css-extract-plugin
export default {"container":"qL-z","timeTop":"rL-z","timeCountdown":"sL-z","cta":"tL-z","disabled":"uL-z","product":"vL-z"};